<template>
    <div class="popup profile-wrap">
        <vue-headful :title="title" :description="title"/>
        <div class="title"> {{ title }}
            <div class="close">
                <a @click.prevent="$store.state.status = null"> <img src="/img/profile/close-x.svg"/> </a>
            </div>
        </div>
        <hr class="hr"/>
        <div class="popup-body">  <!--<div style="margin: 15px">-->  <!--<img src="/img/profile/success.svg"/>-->
            <!--</div>-->
            <div> All your saved cars, searches and user information will be deleted</div>
            <div class="form-group del-confirm">
                <div class="field-wrapper">
                    <input v-model="delConf" class="form-control" id="conf"/>
                    <label :class="{ 'filled-label': delConf && delConf.length > 0 }" for="conf">
                        Confirm by typing <span style="color: darkred;">DELETE</span> below.
                    </label>
                </div>
            </div>
            <btn v-if="btn" @click.native.prevent="del()" :load="load" style="margin-top: 15px; margin-bottom: 30px;"
                 class="btn btn-success">{{ btn }}
            </btn>
        </div>
        <hr class="hr"/>
        <div class="footer"><a href="#" @click.prevent="$store.state.status = null">Cancel</a></div>
    </div>
</template>

<script>
    import btn from "../PreloadBtn.vue";

    export default {
        data: function () {
            return {
                delConf: "",
                title: "Delete confirmation",
                btn: "Delete account",
                load: false
            };
        },
        components: {
            btn: btn
        },
        methods: {
            del() {
                this.load = true;
                let api = this.$store.state.api;
                let th = this;
                if (this.delConf == "DELETE") {
                    FB.api("/me/permissions", "delete", function (r) {
                        let access_token = th.$store.state.access_token;
                        th.$http.get(`${api}/user/del?access-token=${access_token}`).then(function (res) {
                            this.load = false;
                            if (res.body.status == "ok") {
                                th.$store.state.status = null;
                                this.$store.dispatch("GET_PROFILE");
                                this.$store.dispatch("GET_LIB");
                                this.$router.push("/");
                            }
                            console.log("res", res);
                        });
                    });
                }
            }
        }
    };
</script>
